import { Messages } from '../../config';
import {
  ENDPOINT_CLIENT_ORDERS,
  ENDPOINT_CLIENT_USER_ORDERS,
  ENDPOINT_CLIENT_ORDER_RESEND_INVOICE,
  ENDPOINT_CANCEL_REFUND_ORDER,
  ENDPOINT_REFUND_ORDER, ENDPOINT_GET_REFUND_ORDER_DATA,
  ENDPOINT_ORDER_DOWNLOAD, ENDPOINT_ORDER_CANCEL
} from '../../config/endpoints';
import { REFUND_ERROR_CODES } from '../../config/constants';
import { getAxios } from '../axios';
import {
  getTokenHeaders,
  addParam,
  errorCatch,
  getNotificationId
} from '../helper';
import { store } from '../../store/store';
import { NOTIFICATION_ERROR, NOTIFICATION_SUCCESS } from '../../store/actions/types';
import { displayNotification } from '../../store/actions/notification';
import { showGlobalNotification } from '../../store/actions/globalNotification';
import {
  ORDER_REFUND_FAILED,
  ORDER_REFUND_SUCCESS
} from '../../config/messages';
import { download } from "../helper";
import moment from 'moment';

/**
 * Get list of orders
 * @param {object} payload
 * @param {boolean} [payload.disablePagination]
 * @param {boolean} payload.hideNotification
 * @param {object} payload.pagination
 * @param {number} payload.pagination.page
 * @param {number} payload.pagination.per_page
 * @param {string} payload.pagination.sort_by
 * @param {string} payload.pagination.sort
 * @param {string} payload.pagination.q
 * @param {string} payload.pagination.page_context
 * @returns {Promise<T>}
 */
export function getOrdersApi(payload) {
  if (payload && payload.disablePagination === true) {
    if (!payload.pagination) {
      payload.pagination = {};
    }

    payload.pagination.per_page = 100000;
  }

  return getAxios(payload.hideNotification).get(
    addParam(
      ENDPOINT_CLIENT_ORDERS,
      {
        '{order}': '',
      }
    ),
    getTokenHeaders(payload.pagination || null)
  )
    .then(response => {
      return response && response.data ? response.data : null
    })
    .catch(
      e => {
        errorCatch(e, {
          400: 'concat',
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        });

        return e.response;
      }
    );
}

export function getOrderApi(payload) {
  return getAxios(true).get(
    addParam(
      ENDPOINT_CLIENT_ORDERS,
      {
        '{order}': payload.id
      }
    ),
    getTokenHeaders(payload.pagination)
  ).then(response => {
    return response && response.data ? response.data : null;
  })
    .catch(e => {
      errorCatch(e, {
        401: Messages.UNAUTHENTICATED_ERROR,
        403: Messages.UNAUTHORIZED_ERROR,
        404: Messages.NOT_FOUND_ERROR,
      });

      return e.response;
    })
}

/**
 * Get list of user orders
 * @param {object} payload
 * @param {string} payload.userId
 * @param {boolean} payload.hideNotification
 * @param {boolean} [payload.disablePagination]
 * @param {object} payload.pagination
 * @param {number} payload.pagination.page
 * @param {number} payload.pagination.per_page
 * @param {string} payload.pagination.sort_by
 * @param {string} payload.pagination.sort
 * @param {string} payload.pagination.q
 * @param {string} payload.pagination.page_context
 * @returns {Promise<T>}
 */
 export function getUserOrders(payload) {
  if (payload && payload.disablePagination === true) {
    if (!payload.pagination) {
      payload.pagination = {};
    }

    payload.pagination.per_page = 100000;
  }

  return getAxios(payload.hideNotification).get(
    addParam(
      ENDPOINT_CLIENT_USER_ORDERS,
      {
        '{user}': payload.userId,
      }
    ),
    getTokenHeaders(payload.pagination || null)
  )
    .then(response => {
      return response && response.data ? response.data : null
    })
    .catch(
      e => {
        errorCatch(e, {
          400: 'concat',
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        });

        return e.response;
      }
    );
}

/**
 * Resend order email invoice
 * @param {object} payload
 * @param {string} payload.orderId
 * @param {string} payload.notificationId
 * @returns {Promise<T>}
 */
export function resendInvoice(payload) {
  return getAxios(false).post(
    addParam(
      ENDPOINT_CLIENT_ORDER_RESEND_INVOICE,
      {
        '{order}': payload.orderId
      }
    ),
    {},
    getTokenHeaders()
  ).then(response => {
    if (response && response.status === 200) {
      store.dispatch(displayNotification(NOTIFICATION_SUCCESS, Messages.ORDER_RESEND_INVOICE_SUCCESS, payload.notification || null));
      return response;
    }

    return null;
  })
    .catch(e => {
      errorCatch(e, {
        400: 'concat',
        401: Messages.UNAUTHENTICATED_ERROR,
        403: Messages.UNAUTHORIZED_ERROR,
        404: Messages.NOT_FOUND_ERROR,
      }, getNotificationId(payload));

      return e.response;
    })
}

/**
 * Create an admin user
 * @param {object} payload
 * @param {string} payload.notificationId
 * @param {object} payload.data
 * @param {string} payload.data.organization_id
 * @param {string} payload.data.user_id
 * @param {array} payload.data.items
 * @param {object} payload.data.billing
 * @returns {Promise<T>}
 */
export function createOrder(payload) {
  return getAxios()
    .post(
      addParam(
        ENDPOINT_CLIENT_ORDERS,
        {
          "{order}": "",
        } ),
      payload.data,
      getTokenHeaders()
    ).then(
      response => {
        if (response && response.status === 201) {
          store.dispatch( displayNotification( NOTIFICATION_SUCCESS, Messages.CREATE_RESOURCE_SUCCESS, payload.notificationId || null ) );
          return response.data;
        }

        return null;
      }
    ).catch(
      e => {
        errorCatch( e, {
          400: 'concat',
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        }, getNotificationId( payload ) );
        return e.response;
      }
    );
}

/**
 * Get refund data for an order
 * @param {object} payload
 * @param {string} payload.orderId
 */
export const getRefundOrderData = (payload) => {
  return getAxios().get(
    addParam(
      ENDPOINT_GET_REFUND_ORDER_DATA,
      {
        '{orderId}': payload.orderId,
      }
    ),
    getTokenHeaders()
  )
    .then(
      response => {
        return response && response.data ? response.data : null
      }
    )
    .catch(
      e => {
        errorCatch( e, {
          400: 'concat',
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        }, payload.notificationId );

        return null;
      }
    );
}

/**
 * Refund an order
 * @param {object} payload
 * @param {string} payload.orderId
 * @param {string} payload.notificationId
 */
export const refundOrder = (payload) => {
  return getAxios().get(
    addParam(
      ENDPOINT_REFUND_ORDER,
      {
        '{orderId}': payload.orderId,
      }
    ),
    getTokenHeaders()
  )
    .then(
      response => {
        store.dispatch(showGlobalNotification(NOTIFICATION_SUCCESS, ORDER_REFUND_SUCCESS));
        return response;
      }
    )
    .catch(
      e => {
        const errorCode = e && e.response && e.response.data && e.response.data.message
          ? e.response.data.message.error_code
          : null;

        if (e && e.response && e.response.status === 400 && errorCode === REFUND_ERROR_CODES.REFUND_FAILED) {
          store.dispatch(displayNotification(NOTIFICATION_ERROR, ORDER_REFUND_FAILED, payload.notificationId));
          return null;
        }

        errorCatch( e, {
          400: 'concat',
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        }, payload.notificationId );

        return null;
      }
    );
}

/**
 * Cancel initiate refund process of an order
 * @param {object} payload
 * @param {string} payload.orderId
 * @param {string} payload.notificationId
 */
export const cancelRefundOrder = (payload) => {
  return getAxios()
    .get(
      addParam(ENDPOINT_CANCEL_REFUND_ORDER, {
        "{orderId}": payload.orderId,
      }),
      getTokenHeaders()
    )
    .then((response) => {
      return response;
    })
    .catch((e) => {
      errorCatch(
        e,
        {
          400: "concat",
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        },
        payload.notificationId
      );

      return e.response;
    });
}

/**
 * Get order invoice content in inline disposition
 * @param {object} payload
 * @param {number} payload.data.order
 * @param {number} payload.data.date
 * @param {string} payload.notificationId
 */
export const downloadOrderInvoice = (payload) => {
  return download(
    addParam(
      ENDPOINT_ORDER_DOWNLOAD,
      {
        '{order}': payload.data.order,
      }
    ),
    getTokenHeaders(),
    `invoice-${moment(payload.data.date).format('YYYY-MM-DD')}.pdf`
  ).then(
    response => {
      return response && response.data ? response.data : null
    }
  )
    .catch(
      e => {
        errorCatch(e, {
          400: 'concat',
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        }, payload.notificationId);

        return e.response;
      }
    );
}

/**
 * Cancel order
 * @param {object} payload
 * @param {string} payload.orderId
 * @param {string} payload.notificationId
 * @returns {Promise<T>}
 */
export function cancelOrder(payload) {
  return getAxios(false).put(
    addParam(
      ENDPOINT_ORDER_CANCEL,
      {
        '{order}': payload.orderId
      }
    ),
    {},
    getTokenHeaders()
  ).then(response => {
    if (response && response.status === 200) {
      store.dispatch(displayNotification(NOTIFICATION_SUCCESS, Messages.ORDER_CANCEL_SUCCESS, payload.notification || null));
      return response;
    }

    return null;
  })
    .catch(e => {
      errorCatch(e, {
        401: Messages.UNAUTHENTICATED_ERROR,
        403: Messages.UNAUTHORIZED_ERROR,
        404: Messages.NOT_FOUND_ERROR,
      }, getNotificationId(payload));

      return e.response;
    })
}
